interface IState {
  companyAmountWorkHrs: number;
  companyDayOffs: number[];
  isFinishLearningWithEndLr: boolean;
}

export default {
  namespaced: true,
  state: {
    companyAmountWorkHrs: 8,
    companyDayOffs: [0, 6],
    isFinishLearningWithEndLr: false
  } as IState,
  mutations: {
    changeIsFinishLearningWithEndLr(state: IState, value: boolean) {
      state.isFinishLearningWithEndLr = value;
    }
  },
  getters: {
    GET_START_FROM_FINISH: (state: IState) => (
      finishDate: Date,
      hrs: number
    ) => {
      let amountDays: number = Math.ceil(hrs / state.companyAmountWorkHrs) - 1;
      let tempDate = new Date(finishDate);

      while (+amountDays !== 0) {
        tempDate.setDate(tempDate.getDate() - 1);
        if (!state.companyDayOffs.includes(tempDate.getDay())) {
          amountDays--;
        }
      }

      return new Date(tempDate);
    },
    GET_FINISH_FROM_START: (state: IState) => (
      startDate: Date,
      hrs: number
    ) => {
      let amountDays: number = Math.ceil(hrs / state.companyAmountWorkHrs) - 1;
      let tempDate = new Date(startDate);

      while (+amountDays !== 0) {
        tempDate.setDate(tempDate.getDate() + 1);
        if (!state.companyDayOffs.includes(tempDate.getDay())) {
          amountDays--;
        }
      }

      return new Date(tempDate);
    },
    getIsFinishLearningWithEndLr(state: IState) {
      return state.isFinishLearningWithEndLr;
    }
  }
};
